import { render, staticRenderFns } from "./DeleteResponseButton.vue?vue&type=template&id=74402f32&"
import script from "./DeleteResponseButton.vue?vue&type=script&lang=js&"
export * from "./DeleteResponseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports